import { render, staticRenderFns } from "./CheckTf.vue?vue&type=template&id=6450cb95&scoped=true&"
import script from "./CheckTf.vue?vue&type=script&lang=js&"
export * from "./CheckTf.vue?vue&type=script&lang=js&"
import style0 from "./CheckTf.vue?vue&type=style&index=0&id=6450cb95&prod&scoped=true&lang=css&"
import style1 from "./CheckTf.vue?vue&type=style&index=1&id=6450cb95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450cb95",
  null
  
)

export default component.exports